import { Suspense, lazy } from 'react';
// components
import LoadingScreen from '../components/loading-screen';

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// Association portal pages only (AF-06)
// ----------------------------------------------------------------------

export const DashboardOverviewPage = Loadable(
  lazy(() => import('../pages/dashboard/DashboardOverviewPage'))
);

export const PostListPage = Loadable(lazy(() => import('../pages/dashboard/post/PostListPage')));
export const PostCreatePage = Loadable(
  lazy(() => import('../pages/dashboard/post/PostCreatePage'))
);
export const PostEditPage = Loadable(lazy(() => import('../pages/dashboard/post/PostEditPage')));

export const CityListPage = Loadable(lazy(() => import('../pages/dashboard/city/CityListPage')));
export const CityCreatePage = Loadable(
  lazy(() => import('../pages/dashboard/city/CityCreatePage'))
);
export const CityEditPage = Loadable(lazy(() => import('../pages/dashboard/city/CityEditPage')));
export const CityDetailPage = Loadable(
  lazy(() => import('../pages/dashboard/city/CityDetailPage'))
);

export const UploadDocCreateEditPage = Loadable(
  lazy(() => import('../pages/dashboard/upload-document/UploadDocCreateEditPage'))
);

export const MemberListPage = Loadable(
  lazy(() => import('../pages/dashboard/member/MemberListPage'))
);
export const MemberCreatePage = Loadable(
  lazy(() => import('../pages/dashboard/member/MemberCreatePage'))
);
export const MemberEditPage = Loadable(
  lazy(() => import('../pages/dashboard/member/MemberEditPage'))
);
export const MemberDetailPage = Loadable(
  lazy(() => import('../pages/dashboard/member/MemberDetailPage'))
);

export const DesignationinassociationListPage = Loadable(
  lazy(() => import('../pages/dashboard/designationinassociation/DesignationinassociationListPage'))
);
export const DesignationinassociationCreatePage = Loadable(
  lazy(() =>
    import('../pages/dashboard/designationinassociation/DesignationinassociationCreatePage')
  )
);
export const DesignationinassociationEditPage = Loadable(
  lazy(() => import('../pages/dashboard/designationinassociation/DesignationinassociationEditPage'))
);

export const LoginPage = Loadable(lazy(() => import('../pages/auth/LoginPage')));
export const VerifyCodePage = Loadable(lazy(() => import('../pages/auth/VerifyCodePage')));
export const NewPasswordPage = Loadable(lazy(() => import('../pages/auth/NewPasswordPage')));
export const ResetPasswordPage = Loadable(lazy(() => import('../pages/auth/ResetPasswordPage')));

export const Page500 = Loadable(lazy(() => import('../pages/Page500')));
export const Page403 = Loadable(lazy(() => import('../pages/Page403')));
export const Page404 = Loadable(lazy(() => import('../pages/Page404')));
export const PermissionDeniedPage = Loadable(
  lazy(() => import('../pages/dashboard/PermissionDeniedPage'))
);
